import { BaseAPI } from '@services/api';

class API extends BaseAPI {
  constructor() {
    super('localization/division');
  }
}

export default new API();
